const CONTACT_SUPPORT_MESSAGE = 'CONTACT_SUPPORT_MESSAGE';

export const CONTACT_SUPPORT_MESSAGE_MOCK =
    'Por favor entre em contato com o time através de sula@ambevtech.com.br para resolução.';

export default CONTACT_SUPPORT_MESSAGE;
